/**
 * Feature flag téléphonie v2.
 *
 * LOT-SUNSET-0 (bascule actée 2026-09-07) : la v2 est désormais le DÉFAUT.
 * Un appareil neuf — ou un localStorage vidé — tombe sur la scène v2, plus
 * jamais sur la v1. Seul un OPT-OUT EXPLICITE (`telephony_v2 = 'false'`)
 * rend la v1 : retirer la clé ne suffit plus. Kill-switch conservé : poser
 * 'false' + recharger = retour v1 sans déploiement (FlagOffNotice inchangé).
 *
 * IMPORTANT : quand la v2 est active, le TelephonyProvider v2 enregistre
 * le Device Twilio — la v1 (globalTwilioListener) doit alors être ignorée
 * pour cet utilisateur, sinon double sonnerie sur les entrants.
 *
 * Désactivation (console navigateur) : localStorage.setItem('telephony_v2', 'false')
 * Réactivation : localStorage.removeItem('telephony_v2') (ou poser 'true')
 *
 * ⚠️ UN RECHARGEMENT DE PAGE EST OBLIGATOIRE après avoir posé ou retiré le flag.
 *
 * Le flag est relu à CHAQUE rendu des composants qui l'interrogent (provider,
 * gardes de routes, badge) — mais écrire dans `localStorage` ne déclenche
 * AUCUN rendu React. Rien ne se passe donc tant qu'un autre événement ne
 * provoque pas un rendu, et ce qui se passe alors dépend de quels composants
 * se rendent : on obtient un état MIXTE (provider v2 non monté alors que les
 * routes v1 se croient déjà remplacées, ou l'inverse — deux Devices Twilio
 * enregistrés = double sonnerie). Le cycle de vie du Device, lui, est piloté
 * par un `useEffect` dont `enabled` fait partie des dépendances : sans rendu,
 * il ne rejoue pas.
 *
 * `setTelephonyV2Enabled` ne recharge pas elle-même : le rechargement
 * appartient à l'appelant, qui sait ce qu'il a en cours (un appel actif ne doit
 * pas être coupé par une bascule de flag).
 */
const FLAG_KEY = 'telephony_v2';

export function isTelephonyV2Enabled(): boolean {
  try {
    // S0-B : défaut TRUE — seule la valeur 'false' (opt-out explicite) rend
    // la v1. Une clé absente, vidée ou 'true' donne la v2.
    return localStorage.getItem(FLAG_KEY) !== 'false';
  } catch {
    // localStorage inaccessible (navigation privée…) : on suit le défaut.
    return true;
  }
}

export function setTelephonyV2Enabled(enabled: boolean): void {
  if (enabled) {
    localStorage.setItem(FLAG_KEY, 'true');
  } else {
    // L'opt-out doit être EXPLICITE : supprimer la clé redonnerait le défaut
    // (v2). On écrit 'false'.
    localStorage.setItem(FLAG_KEY, 'false');
  }
}
